import { useEffect, useState } from "react";
import { produce } from "immer";
import { useSectionEffectsContext } from "@ecp-boxes/structure/Contexts/SectionEffectsContext";

export type TSectionValidationLookup = {
  contact: boolean;
  address: boolean;
  payment: boolean;
  billingAddress: boolean;
  delivery: boolean;
};
export const useSectionValidation = (purchaseButtonTimestamp: number) => {
  const [sectionValidationLookup, setSectionValidationLookup] =
    useState<TSectionValidationLookup>({
      contact: false,
      address: false,
      delivery: false,
      payment: false,
      billingAddress: false,
    });

  const { totalStickyEffectsHeight } = useSectionEffectsContext();

  const setSectionValidation = (
    section: keyof TSectionValidationLookup,
    isValid: boolean
  ) => {
    setSectionValidationLookup(
      produce((draft) => {
        draft[section] = isValid;
      })
    );
  };

  const isEverySectionValid = Object.values(sectionValidationLookup).every(
    (isValid) => isValid
  );

  const firstInvalidSection = Object.keys(sectionValidationLookup).find(
    (section) =>
      !sectionValidationLookup[section as keyof TSectionValidationLookup]
  );

  useEffect(() => {
    const scrollWrapper = document?.getElementById("scroll-wrapper");

    if (purchaseButtonTimestamp && firstInvalidSection) {
      const invalidSectionRef = document.getElementById(
        `${firstInvalidSection}-section`
      );
      if (!invalidSectionRef || !scrollWrapper) return;

      const y =
        invalidSectionRef.getBoundingClientRect().top +
        scrollWrapper.scrollTop -
        totalStickyEffectsHeight;

      scrollWrapper?.scrollTo({ top: y, behavior: "smooth" });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [purchaseButtonTimestamp]);

  return {
    sectionValidationLookup,
    setSectionValidation,
    isEverySectionValid,
    firstInvalidSection,
  };
};

export type TUseSectionValidation = ReturnType<typeof useSectionValidation>;
